import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;
  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
    max-height: 100%;
    overflow-y: scroll;
    background-color: white;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(231deg, #ececec, #ffffff, #f5f5f5);
  z-index: 1;
  padding: 0 73px 0 73px;
  overflow-y: auto;
  padding-bottom: 20px;
  @media (max-width: 768px) {
    padding: 24px;
    background-image: none;
    background-color: white;
    margin-top: -15px;
    padding-bottom: 53px;
    border-radius: 15px 15px 0 0;
    overflow-y: initial;
  }
`;

export const Body = styled.main`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
